import { Theme } from "@mui/material";
import { minWidth, textAlign } from "@mui/system";

const useStyles = (theme: Theme) => ({
  stackPage: {
    width: "100%",
    height: "100%",
    padding: { xs: "10%", md: "50px" },
  },
  paperForm: {
    padding: "24px 32px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: { xs: "100%", md: "500px" },
    minWidth: "200px",
    gap: "12px",
  },
  title: {
    fontSize: "24px",
    fontWeight: 500,
  },
  subtitle: {
    fontSize: "14px",
    color: theme.palette.text.secondary,
    fontWeight: 500,
    textAlign: "center",
  },
  backgroundBox: {
    zIndex: -1,
    height: "100vh",
    width: "100vw",
    position: "absolute",
    top: 0,
    // backgroundImage: `url(${background})`,
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
    backgroundRepeat: "no-repeat",
    filter: "blur(5px)",
  },
  paperContainer: {
    minWidth: "350px",
    padding: "20px 50px",
    width: { xs: "95vw", sm: "500px" },
    margin: "auto",
    marginTop: "20vh",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    display: "flex",
  },
  backButton: {
    display: "flex",
    minWidth: "0px",
    marginLeft: "-90%",
    fontSize: "11px",
    height: "35px",
  },
  stackContainer: {
    direction: "column",
    gap: "15px",
    alignItems: "center",
    padding: "0px",
    width: "100%",
  },
  logoImage: {
    height: "auto",
    width: "250px",
  },
  loadingLogo: {
    position: "relative",
    margin: "50px",
  },
  circularProgress: {
    color: "primary",
    position: "absolute",
    top: -9,
    left: -6,
    zIndex: 1,
  },
  descriptionText: {
    fontSize: "1em",
    fontFamily: "Rubik",
    textAlign: "center",
  },
  formControl: {
    m: 1,
    width: "100%",
    marginTop: "0px",
  },
  sendButton: {
    width: "90%",
    borderRadius: "5px",
    marginTop: "10px",
    height: "40px",
    marginBottom: "20px",
  },
  successText: {
    fontSize: "1.1em",
    fontFamily: "Rubik",
    textAlign: "center",
    mb: "20px",
    padding: "10px",
    backgroundColor: "rgba(0, 0, 0,0.1)",
  },
  codeAlertText: {
    fontSize: "13px",
    marginTop: "-10px",
    color: "#e83750",
    marginBottom: "-20px",
  },
  verifyButton: {
    width: "50%",
    borderRadius: "5px",
    marginTop: "20px",
    height: "40px",
    marginBottom: "20px",
  },
  resendLink: {
    width: "100%",
    textDecoration: "none!important",
    marginBottom: "20px",
    textAlign: "center",
  },
});

export default useStyles;
